import { h } from 'preact';
import { useSelector } from 'react-redux';

import { routesSelector } from '@core/state/routes/routesSelector';
import { currentPageSelector } from '@core/state/page/pageSelectors';
import translate from '@core/translate';
import withProvider from '@core/state/withProvider';
import Breadcrumbs from '@ui/Breadcrumbs/Breadcrumbs';

function BreadcrumbsManufacturer() {
    const { routes } = useSelector(routesSelector);
    const { name } = useSelector(currentPageSelector);

    return (
        <Breadcrumbs
            breadcrumbs={[
                {
                    id: 0,
                    name: translate('breadcrumb.home'),
                    seName: routes.home,
                },
                {
                    id: 1,
                    name: translate('breadcrumb.manufacturers'),
                    seName: routes.manufacturers,
                }, {
                    id: 2,
                    name,
                    seName: false,
                },
            ]}
        />
    );
}

export default withProvider(BreadcrumbsManufacturer);